<template>
  <RModal ref="modal" :persistent="false" title="Create new item" @ok="onSave" @cancel="hide">
    <Grid gtc="repeat(3, 200px)" gap="20px" class="modal-content q-pt-sm">
      <div class="textarea">
        <RLabel>Description</RLabel>
        <q-input v-model="description" autofocus autogrow outlined dense />
      </div>

      <RInput
        id="price"
        :value="price.value"
        autofocus
        no-hint
        no-feedback-icon
        label="Original price"
        on-clear="focus"
        @clear="priceCleave.setRawValue(null)"
      />

      <RInput
        id="local-price"
        :value="normalizedPrice.value"
        autofocus
        no-hint
        no-feedback-icon
        label="Local price"
        on-clear="focus"
        @clear="localPriceCleave.setRawValue(null)"
      />
    </Grid>
  </RModal>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import Cleave from 'cleave.js'
// Components
import RModal from '@/ui/RModal'
import RLabel from '@/ui/shared/RLabel'

export default {
  components: {
    RModal,
    RLabel
  },

  props: {
    periodId: Number
  },

  data: () => ({
    description: null,
    price: { value: '', rawValue: '' },
    normalizedPrice: { value: '', rawValue: '' }
  }),

  computed: {
    payload() {
      return {
        description: this.description,
        price: this.price.rawValue ? +this.price.rawValue : null,
        normalized_price: this.normalizedPrice.rawValue ? +this.normalizedPrice.rawValue : null
      }
    }
  },

  created() {
    this.priceCleave = null
    this.localPriceCleave = null
  },

  methods: {
    show() {
      this.$refs.modal.show()
      this.$nextTick(() => this.setCleaveFields())
    },

    hide() {
      this.$refs.modal.hide()
    },

    setCleaveFields() {
      this.priceCleave = this.newCleave('#price .q-field__native', 2, ({ target: valueChanged }) => {
        this.price.value = valueChanged.value
        this.price.rawValue = valueChanged.rawValue
      })
      this.localPriceCleave = this.newCleave('#local-price .q-field__native', 2, ({ target: valueChanged }) => {
        this.normalizedPrice.value = valueChanged.value
        this.normalizedPrice.rawValue = valueChanged.rawValue
      })
    },

    newCleave(id, numeralDecimalScale = 2, valueChangedCallback = () => {}) {
      const delimiter = this.settings.thousand_separator

      return new Cleave(id, {
        numeral: true,
        numeralDecimalMark: this.settings.decimal_separator,
        delimiter: delimiter === 'space' ? ' ' : delimiter,
        numeralDecimalScale,
        onValueChanged: valueChangedCallback
      })
    },

    onSave(hideModal, setModalLoading) {
      setModalLoading(true)

      apiTo
        .CREATE_SUBSCRIPTION_PERIOD_ITEM(this.periodId, this.payload)
        .then(({ data }) => {
          this.$emit('created', data.result)
          hideModal()
          this.resetData()
        })
        .finally(() => setModalLoading(false))
    },

    resetData() {
      this.description = null
      this.priceCleave.setRawValue(null)
      this.localPriceCleave.setRawValue(null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.textarea {
  grid-row: span 2;

  @include q-field__control {
    min-height: var(--r-field-height) !important;
    background: var(--r-white-1);
    border: 1px solid var(--r-white-5);
    padding: 0 16px !important;

    .q-field__control-container {
      padding: 0 !important;
    }

    &:before,
    &:after {
      display: none !important;
    }

    &:hover {
      border: 1px solid var(--r-secondary-4);
    }

    textarea {
      min-height: calc(var(--r-field-height) - 2px);
      @extend .text-body-1;
      color: var(--r-secondary-1);
    }
  }

  .q-textarea.q-field--focused {
    @include q-field__control {
      border: 1px solid var(--r-secondary-4);
    }
  }
}
</style>
